import {
  Building2,
  Users,
  Plane,
  Bus,
  Ship,
  Car,
  Compass,
  ShieldCheck,
  UtensilsCrossed,
  Store,
  Ticket,
} from 'lucide-react';

const icons: Record<string, typeof Users> = {
  M: Users,
  W: Users,
  E: Building2,
  O: Building2,
  H: Plane,
  T: Bus,
  C: Ship,
  RC: Car,
  R: Compass,
  I: ShieldCheck,
  Q: UtensilsCrossed,
  S: Store,
  D: Ticket,
};

export function cariTypeDisplay(code: string) {
  return {
    icon: icons[code] ?? Building2,
    bgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    hoverBorder: 'hover:border-primary',
  };
}

export function cariTypeLabel(type: { name: string; nameEn?: string | null }, language: string) {
  return language.startsWith('en') && type.nameEn ? type.nameEn : type.name;
}
